import { FocusSDK } from "@/utils";
import { v4 } from "uuid";
import { DynamicObject } from "@/types/common";
import log from "@/utils/logger";

const windowMap: DynamicObject = {};

/**
 * window.open打开新窗口
 * 注意需要同源才能发送消息
 */
export async function handleNewWindow(opts: any) {
  return new Promise((resolve, reject) => {
    if (!opts.url) {
      reject(new Error("url不能为空"));
      return;
    }
    let url = opts.url;
    let dialogId = opts.cid || v4();
    if (windowMap[dialogId] && !windowMap[dialogId].closed) {
      windowMap[dialogId].focus();
      reject(new Error("窗口已经打开"));
      return;
    }
    let features = opts.features;
    let dialog = window.open(
      url,
      "_blank",
      `__portalType=modal,preferences=${encodeURIComponent(JSON.stringify(features))}`
    );
    windowMap[dialogId] = dialog;
    if (dialog) {
      // @ts-ignore
      dialog.window.parent = window;
      dialog.window["__dialogId"] = dialogId;
      let readyHandler = (e: MessageEvent) => {
        let msg = JSON.parse(e.data);
        if (msg["dialogId"] === dialogId) {
          window.removeEventListener("message", readyHandler);
          if (opts.data) {
            (dialog as any).postMessage({
              type: "initData",
              value: opts.data
            });
          }
          let beforeunload = () => {
            if (dialog?.__dialogId) {
              Reflect.deleteProperty(windowMap, dialog.__dialogId);
              dialog?.removeEventListener("beforeunload", beforeunload);
              dialog = null;
            }
          };
          dialog?.addEventListener("beforeunload", beforeunload);
          FocusSDK.sendIpcMessage("window.openNewWindow", { dialogId });
          resolve(dialog as Window);
        }
      };
      window.addEventListener("message", readyHandler);
    } else {
      reject(new Error("窗口打开失败"));
    }
  });
}

export function handleWindowData(data: any) {
  log.debug("handleWindowData", data);
  const dialog = windowMap[data.cid];
  if (dialog && !dialog.closed) {
    (dialog as any).postMessage({
      type: data.type,
      value: data.data
    });
  }
}
